"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.DynamicAttributeType = exports.WorkflowGuardAlias = exports.WorkflowActionAlias = exports.WorkflowCallbackType = void 0;
var api_service_1 = require("./api-service");
var client_1 = require("../client");
var SettingService = /** @class */ (function (_super) {
    __extends(SettingService, _super);
    function SettingService() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.endpoint = 'settings';
        return _this;
    }
    SettingService.prototype.organisations = function () {
        return this.getRequest(this.url('organisations'));
    };
    SettingService.prototype.organisation = function (id) {
        return this.getRequest(this.url('organisations', id));
    };
    SettingService.prototype.createOrganisation = function (data) {
        return this.postRequest(this.url('organisations'), data);
    };
    SettingService.prototype.updateOrganisation = function (id, data) {
        return this.putRequest(this.url('organisations', id), data);
    };
    SettingService.prototype.deleteOrganisation = function (organisation) {
        var id = typeof organisation === 'number' ? organisation : organisation.id;
        return this.deleteRequest(this.url('organisations', id));
    };
    SettingService.prototype.stores = function (organisation) {
        return this.getRequest(this.url('stores'), (0, client_1.organisationToHeaders)(organisation));
    };
    SettingService.prototype.createStore = function (organisationId, store) {
        return this.postRequest(this.url('stores'), store, (0, client_1.organisationToHeaders)(organisationId));
    };
    SettingService.prototype.updateStore = function (id, data) {
        return this.putRequest(this.url('stores', id), data, {
            headers: { 'x-store-id': null },
        });
    };
    SettingService.prototype.deleteStore = function (store) {
        return this.deleteRequest(this.url('stores', store.id), {
            headers: (0, client_1.organisationToHeaders)(store.organisation),
        });
    };
    SettingService.prototype.languages = function () {
        return this.getRequest(this.url('languages'));
    };
    SettingService.prototype.addLanguage = function (lang) {
        return this.postRequest(this.url('languages'), lang);
    };
    // TODO - to be rewritten after platform update to use PUT, instead of POST
    SettingService.prototype.updateLanguage = function (data) {
        return this.addLanguage(data);
    };
    SettingService.prototype.deleteLanguage = function (language) {
        var code = typeof language === 'object' ? language.code : language;
        return this.deleteRequest(this.url('languages', code));
    };
    SettingService.prototype.countries = function () {
        return this.getRequest(this.url('countries'));
    };
    SettingService.prototype.getCountry = function (code) {
        return this.getRequest(this.url('countries', code));
    };
    SettingService.prototype.getCountryRegion = function (code) {
        return this.getRequest(this.url('countries', code, 'regions'));
    };
    SettingService.prototype.abilities = function () {
        return this.getRequest(this.url('abilities'));
    };
    SettingService.prototype.getSetting = function (code) {
        return this.getRequest(this.url('settings', dotsToSlashes(code || '')));
    };
    SettingService.prototype.updateSetting = function (code, data) {
        return this.putRequest(this.url('settings', dotsToSlashes(code)), { data: data });
    };
    SettingService.prototype.dynamicAttributes = function (params) {
        return this.getCollectionRequest(this.url('dynamic', 'attributes'), {
            params: params,
        });
    };
    SettingService.prototype.getDynamicAttribute = function (id) {
        return this.getRequest(this.url('dynamic', 'attributes', id));
    };
    SettingService.prototype.createDynamicAttribute = function (data) {
        return this.postRequest(this.url('dynamic', 'attributes'), data);
    };
    SettingService.prototype.updateDynamicAttribute = function (id, data) {
        return this.putRequest(this.url('dynamic', 'attributes', id), data);
    };
    SettingService.prototype.deleteDynamicAttribute = function (id) {
        return this.deleteRequest(this.url('dynamic', 'attributes', id));
    };
    SettingService.prototype.dynamicGroups = function (params) {
        return this.getCollectionRequest(this.url('dynamic', 'groups'), {
            params: params,
        });
    };
    SettingService.prototype.getDynamicGroup = function (id) {
        return this.getRequest(this.url('dynamic', 'groups', id));
    };
    SettingService.prototype.createDynamicGroup = function (data) {
        return this.postRequest(this.url('dynamic', 'groups'), data);
    };
    SettingService.prototype.updateDynamicGroup = function (id, data) {
        return this.putRequest(this.url('dynamic', 'groups', id), data);
    };
    SettingService.prototype.deleteDynamicGroup = function (id) {
        return this.deleteRequest(this.url('dynamic', 'groups', id));
    };
    SettingService.prototype.dynamicResources = function (params) {
        return this.getRequest(this.url('dynamic', 'resources'), { params: params });
    };
    SettingService.prototype.serviceResources = function (params) {
        return this.getRequest(this.url('service', 'resources'), { params: params });
    };
    return SettingService;
}(api_service_1.ApiService));
exports.default = SettingService;
var dotsToSlashes = function (code) {
    return code.replace('.', '/');
};
var WorkflowCallbackType;
(function (WorkflowCallbackType) {
    WorkflowCallbackType["GUARD"] = "guard";
    WorkflowCallbackType["ACTION"] = "action";
})(WorkflowCallbackType = exports.WorkflowCallbackType || (exports.WorkflowCallbackType = {}));
var WorkflowActionAlias;
(function (WorkflowActionAlias) {
    WorkflowActionAlias["RESTOCK_ORDER"] = "restock.order";
    WorkflowActionAlias["ORDER_HOLD_REASON"] = "order.hold.reason";
    WorkflowActionAlias["RELEASE_ORDER"] = "release.order";
    WorkflowActionAlias["REFUND_ORDER"] = "refund.order";
    WorkflowActionAlias["SHIP_ORDER"] = "ship.order";
    WorkflowActionAlias["VALIDATE_ORDER"] = "validate.order";
    WorkflowActionAlias["VOID_ORDER"] = "void.order";
    WorkflowActionAlias["REQUESTED_DELIVERY_COMMENT"] = "requested.delivery.comment";
    WorkflowActionAlias["BILL_ONLINE_ORDER"] = "bill.online.order";
    WorkflowActionAlias["BILL_OFFLINE_ORDER"] = "bill.offline.order";
    WorkflowActionAlias["COMMENT_ORDER"] = "comment.order";
})(WorkflowActionAlias = exports.WorkflowActionAlias || (exports.WorkflowActionAlias = {}));
var WorkflowGuardAlias;
(function (WorkflowGuardAlias) {
    WorkflowGuardAlias["CONDITION_CHECK"] = "condition.check";
    WorkflowGuardAlias["CAN_CANCEL_ORDER"] = "can.cancel.order";
    WorkflowGuardAlias["CAN_REFUND_ORDER"] = "can.refund.order";
    WorkflowGuardAlias["CAN_PROCESS_ORDER"] = "can.process.order";
    WorkflowGuardAlias["CAN_VOID_ORDER"] = "can.void.order";
    WorkflowGuardAlias["IS_PAID_ORDER"] = "is.paid.order";
    WorkflowGuardAlias["IS_REFUNDED_ORDER"] = "is.refunded.order";
    WorkflowGuardAlias["CAN_FULFILL_ORDER"] = "can.fulfill.order";
})(WorkflowGuardAlias = exports.WorkflowGuardAlias || (exports.WorkflowGuardAlias = {}));
var DynamicAttributeType;
(function (DynamicAttributeType) {
    DynamicAttributeType["STRING"] = "string";
    DynamicAttributeType["TEXT"] = "text";
    DynamicAttributeType["NUMERIC"] = "numeric";
    DynamicAttributeType["BOOLEAN"] = "boolean";
    DynamicAttributeType["SELECT"] = "select";
    DynamicAttributeType["SELECT_MULTIPLE"] = "select-multiple";
    DynamicAttributeType["CHECKBOX"] = "checkbox";
    DynamicAttributeType["COMBOBOX"] = "combobox";
    DynamicAttributeType["MONEY"] = "money";
    DynamicAttributeType["LINKED"] = "linked";
})(DynamicAttributeType = exports.DynamicAttributeType || (exports.DynamicAttributeType = {}));
//# sourceMappingURL=setting-service.js.map